import React, { PropTypes } from 'react';
import StyleButton from './StyleButton.js.jsx';

var INLINE_STYLES = [
  {label: <strong>B</strong>, style: 'BOLD'},
  {label: <em>I</em>, style: 'ITALIC'},
  {label: <u>U</u>, style: 'UNDERLINE'},
];

const InlineStyleControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type, i) =>
        <StyleButton
          key={i}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

export default InlineStyleControls;



// WEBPACK FOOTER //
// global/components/forms/editorComponents/InlineStyleControls.js.jsx